// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.epsmINsyVJIUZQv2_oqT {
  text-align: center;
}

:root {
  --accent-text-color: #ffffff;
  --text-color: #FECB00;
  --accent-color: #005293; /* Default accent for day mode */
  --border-color: #007ee1;

}



body{
  color: var(--text-color);
  font-family: 'Roboto';
}

#LxAP_0jsDDHDRIywnUmI{
  width: 400px;
  border: 5px solid var(--border-color);
  border-radius: 10px;
}

.xNMRDlpVzAXUco13r1p2 {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .xNMRDlpVzAXUco13r1p2 {
    animation: Wo70hR4WrAm0Et8P5hto infinite 20s linear;
  }
}

.UpsTp6hwqyyXqujs4p7T {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

._azf1A_mg91roFkz3AxY {
  color: #61dafb;
}

@keyframes Wo70hR4WrAm0Et8P5hto {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.GI_qJ8RicbKre3AMqcbR {
  padding: 20px;
  border: 4px solid var(--border-color);
  border-radius: 10px;
  background-color: var(--accent-color);
  width: 600px;
  /* margin: 20px auto; */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  font-family: 'Roboto';
}

.GI_qJ8RicbKre3AMqcbR h3 {
  text-align: center;
  color: var(--accent-text-color);
  font-size: 1.5rem;
}

.kafNB6fnf95YmDT9rmi7 {
  margin-bottom: 20px;
  border-bottom: 1px solid var(--accent-text-color)
}

.kafNB6fnf95YmDT9rmi7 h4 {
  margin-bottom: 10px;
  font-size: 1.2rem;
  color: var(--accent-text-color);
  border-bottom: 1px solid var(--accent-color);
  padding-bottom: 5px;
}

.kafNB6fnf95YmDT9rmi7 label {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: var(--accent-text-color);
  margin-bottom: 10px;
}

.kafNB6fnf95YmDT9rmi7 label input[type="checkbox"] {
  margin-right: 5px;
}

.kafNB6fnf95YmDT9rmi7 label input[type="color"] {
  width: 30px;
  height: 30px;
  border: none;
  padding: 0;
  cursor: pointer;
}

.kafNB6fnf95YmDT9rmi7 label input[type="range"] {
  width: 100%;
}

span {
  font-size: 12px;
  color: #666;
  margin-left: 5px;
}

.PDGrjD704Ob8G1kRxp1h {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  align-items: center;
}

.IhR5wzuy5KvwHKDqdK_k {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 20px;
  align-items: flex-start;
  flex-wrap: wrap; /* Allows items to wrap onto a new row */
  align-items: center;
  justify-content: center;
}


@media (max-width: 768px) {
  .IhR5wzuy5KvwHKDqdK_k {
    flex-direction: column; /* Stack items vertically on smaller screens */
  }
}

.HKZlGZdjjTrclIFuI7r8 div {
  white-space: nowrap; /* Prevent text wrapping */
  text-overflow: ellipsis; /* Apply ellipsis to truncated text */
}

.HKZlGZdjjTrclIFuI7r8 p {
  margin: 0; /* Remove default paragraph margins */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.WadwcjJo8Qw7oIn7USj1{
  position: fixed;
  top: 10px;
  right: 10px;
  padding: 10px 20px;
  background-color: var(--accent-color);
  color: var(--accent-text-color);
  border-radius: 5px;
  border: double 2px var(--border-color);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  z-index: 1000;
}



/* Video Container */
.hg5c_J37HgAvDH5LSARu {
  width: 100%;
  height: 300px;
  margin-top: 20px;
  border-radius: 8px;
  overflow: hidden;
}


button {
  border-radius: 80px !important;
  border: double 2px var(--border-color);
  background-image: linear-gradient(var(--text-color), var(--text-color));
  /* background-clip: padding-box, border-box; */
  cursor: pointer;
  padding: 10px 15px; /* Initial padding */
  align-items: center;
  justify-content: center;
  color: var(--border-color);
  transition: padding 0.2s ease; /* Smooth transition for padding */
  font-weight: 900;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* Optional shadow for depth */
  text-shadow: 0px 0px 0px #008cff;
}

.mwg5gKy0EM9GdmHaYbJM{
  margin: 20px;
}

button:hover {
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* Optional shadow for depth */
  background-image: linear-gradient(var(--border-color), var(--border-color));
  color: var(--accent-text-color);
  /* border: 5px solid var(--accent-color); */
}

/* Container for pre-login section */
.grlaJmWeLMyGC28uwmh4 {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px; /* Space between image and text */
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto; /* Center the container */
}

/* Flex direction for small screens */
@media (max-width: 768px) {
  .grlaJmWeLMyGC28uwmh4 {
    flex-direction: column; /* Stack elements vertically */
  }

  .MRUtLjwf1qiLu1G2eZ6Q, .VH1K4m8DDCw4hFvAP0UE {
    width: 100%; /* Ensure elements take full width */
    text-align: center !important; /* Center-align text for better presentation */
  }
}

/* Image container styling */
.VH1K4m8DDCw4hFvAP0UE {
  flex: 1; /* Allows the image to take up equal space */
}

.WZey2nQwLbLFCYMnApVe {
  max-width: 450px; /* Optional: Limit max width of the image */
  height: auto; /* Maintain aspect ratio */
  border-radius: 10px; /* Optional: Rounded corners */
  border: 5px solid var(--border-color);
}

/* Text container styling */
.MRUtLjwf1qiLu1G2eZ6Q {
  flex: 2; /* Allows text to take up more space */
  text-align: left;
}

.dgscOEiRmCgRColWrEGD {
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 10px;
}

.tAfR6PoYvluj6kXEQYA9 {
  font-size: 1rem;
  margin-bottom: 20px;
}

.aeLFsmoxA_by4CGRyat3 {
  outline: 2px solid var(--border-color);
  width: 750px; /* Default width */

  /* Scale down for smaller screens */
  max-width: 100%; /* Prevent overflow */
  height: auto; /* Maintain aspect ratio */
  margin: 25px;
  border: 5px solid var(--border-color);
  border-radius: 10px;
}

@media (max-width: 768px) {
  .aeLFsmoxA_by4CGRyat3 {
    width: 90%; /* Adjust width to 90% of the container */
  }
}

.ROMCClNVSsmfJfXdGfXJ{
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-direction: row;
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/Showcase.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,uBAAuB,EAAE,gCAAgC;EACzD,uBAAuB;;AAEzB;;;;AAIA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,mDAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mBAAmB;EACnB,qCAAqC;EACrC,YAAY;EACZ,uBAAuB;EACvB,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;EAC/B,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;EACvB,eAAe,EAAE,wCAAwC;EACzD,mBAAmB;EACnB,uBAAuB;AACzB;;;AAGA;EACE;IACE,sBAAsB,EAAE,8CAA8C;EACxE;AACF;;AAEA;EACE,mBAAmB,EAAE,0BAA0B;EAC/C,uBAAuB,EAAE,qCAAqC;AAChE;;AAEA;EACE,SAAS,EAAE,qCAAqC;EAChD,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,sCAAsC;EACtC,wCAAwC;EACxC,aAAa;AACf;;;;AAIA,oBAAoB;AACpB;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,8BAA8B;EAC9B,sCAAsC;EACtC,uEAAuE;EACvE,8CAA8C;EAC9C,eAAe;EACf,kBAAkB,EAAE,oBAAoB;EACxC,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,6BAA6B,EAAE,kCAAkC;EACjE,gBAAgB;EAChB,uCAAuC,EAAE,8BAA8B;EACvE,gCAAgC;AAClC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uCAAuC,EAAE,8BAA8B;EACvE,2EAA2E;EAC3E,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS,EAAE,iCAAiC;EAC5C,aAAa;EACb,iBAAiB;EACjB,cAAc,EAAE,yBAAyB;AAC3C;;AAEA,qCAAqC;AACrC;EACE;IACE,sBAAsB,EAAE,8BAA8B;EACxD;;EAEA;IACE,WAAW,EAAE,oCAAoC;IACjD,6BAA6B,EAAE,8CAA8C;EAC/E;AACF;;AAEA,4BAA4B;AAC5B;EACE,OAAO,EAAE,4CAA4C;AACvD;;AAEA;EACE,gBAAgB,EAAE,2CAA2C;EAC7D,YAAY,EAAE,0BAA0B;EACxC,mBAAmB,EAAE,8BAA8B;EACnD,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE,OAAO,EAAE,sCAAsC;EAC/C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,sCAAsC;EACtC,YAAY,EAAE,kBAAkB;;EAEhC,mCAAmC;EACnC,eAAe,EAAE,qBAAqB;EACtC,YAAY,EAAE,0BAA0B;EACxC,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU,EAAE,yCAAyC;EACvD;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":[".App {\n  text-align: center;\n}\n\n:root {\n  --accent-text-color: #ffffff;\n  --text-color: #FECB00;\n  --accent-color: #005293; /* Default accent for day mode */\n  --border-color: #007ee1;\n\n}\n\n\n\nbody{\n  color: var(--text-color);\n  font-family: 'Roboto';\n}\n\n#gif{\n  width: 400px;\n  border: 5px solid var(--border-color);\n  border-radius: 10px;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.widget-customization {\n  padding: 20px;\n  border: 4px solid var(--border-color);\n  border-radius: 10px;\n  background-color: var(--accent-color);\n  width: 600px;\n  /* margin: 20px auto; */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  font-family: 'Roboto';\n}\n\n.widget-customization h3 {\n  text-align: center;\n  color: var(--accent-text-color);\n  font-size: 1.5rem;\n}\n\n.config-group {\n  margin-bottom: 20px;\n  border-bottom: 1px solid var(--accent-text-color)\n}\n\n.config-group h4 {\n  margin-bottom: 10px;\n  font-size: 1.2rem;\n  color: var(--accent-text-color);\n  border-bottom: 1px solid var(--accent-color);\n  padding-bottom: 5px;\n}\n\n.config-group label {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 14px;\n  color: var(--accent-text-color);\n  margin-bottom: 10px;\n}\n\n.config-group label input[type=\"checkbox\"] {\n  margin-right: 5px;\n}\n\n.config-group label input[type=\"color\"] {\n  width: 30px;\n  height: 30px;\n  border: none;\n  padding: 0;\n  cursor: pointer;\n}\n\n.config-group label input[type=\"range\"] {\n  width: 100%;\n}\n\nspan {\n  font-size: 12px;\n  color: #666;\n  margin-left: 5px;\n}\n\n.optionspreviewrow {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n  align-items: center;\n}\n\n.customization-preview-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  gap: 20px;\n  align-items: flex-start;\n  flex-wrap: wrap; /* Allows items to wrap onto a new row */\n  align-items: center;\n  justify-content: center;\n}\n\n\n@media (max-width: 768px) {\n  .customization-preview-container {\n    flex-direction: column; /* Stack items vertically on smaller screens */\n  }\n}\n\n.widget-preview div {\n  white-space: nowrap; /* Prevent text wrapping */\n  text-overflow: ellipsis; /* Apply ellipsis to truncated text */\n}\n\n.widget-preview p {\n  margin: 0; /* Remove default paragraph margins */\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.notification{\n  position: fixed;\n  top: 10px;\n  right: 10px;\n  padding: 10px 20px;\n  background-color: var(--accent-color);\n  color: var(--accent-text-color);\n  border-radius: 5px;\n  border: double 2px var(--border-color);\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);\n  z-index: 1000;\n}\n\n\n\n/* Video Container */\n.video-container {\n  width: 100%;\n  height: 300px;\n  margin-top: 20px;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n\nbutton {\n  border-radius: 80px !important;\n  border: double 2px var(--border-color);\n  background-image: linear-gradient(var(--text-color), var(--text-color));\n  /* background-clip: padding-box, border-box; */\n  cursor: pointer;\n  padding: 10px 15px; /* Initial padding */\n  align-items: center;\n  justify-content: center;\n  color: var(--border-color);\n  transition: padding 0.2s ease; /* Smooth transition for padding */\n  font-weight: 900;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* Optional shadow for depth */\n  text-shadow: 0px 0px 0px #008cff;\n}\n\n.divsection{\n  margin: 20px;\n}\n\nbutton:hover {\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2); /* Optional shadow for depth */\n  background-image: linear-gradient(var(--border-color), var(--border-color));\n  color: var(--accent-text-color);\n  /* border: 5px solid var(--accent-color); */\n}\n\n/* Container for pre-login section */\n.pre-login-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 20px; /* Space between image and text */\n  padding: 20px;\n  max-width: 1000px;\n  margin: 0 auto; /* Center the container */\n}\n\n/* Flex direction for small screens */\n@media (max-width: 768px) {\n  .pre-login-container {\n    flex-direction: column; /* Stack elements vertically */\n  }\n\n  .text-container, .image-container {\n    width: 100%; /* Ensure elements take full width */\n    text-align: center !important; /* Center-align text for better presentation */\n  }\n}\n\n/* Image container styling */\n.image-container {\n  flex: 1; /* Allows the image to take up equal space */\n}\n\n.placeholder-image {\n  max-width: 450px; /* Optional: Limit max width of the image */\n  height: auto; /* Maintain aspect ratio */\n  border-radius: 10px; /* Optional: Rounded corners */\n  border: 5px solid var(--border-color);\n}\n\n/* Text container styling */\n.text-container {\n  flex: 2; /* Allows text to take up more space */\n  text-align: left;\n}\n\n.title-text {\n  font-size: 2rem;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.sub-text {\n  font-size: 1rem;\n  margin-bottom: 20px;\n}\n\n.responsive-image {\n  outline: 2px solid var(--border-color);\n  width: 750px; /* Default width */\n\n  /* Scale down for smaller screens */\n  max-width: 100%; /* Prevent overflow */\n  height: auto; /* Maintain aspect ratio */\n  margin: 25px;\n  border: 5px solid var(--border-color);\n  border-radius: 10px;\n}\n\n@media (max-width: 768px) {\n  .responsive-image {\n    width: 90%; /* Adjust width to 90% of the container */\n  }\n}\n\n.content-center{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  flex-direction: row;\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `epsmINsyVJIUZQv2_oqT`,
	"gif": `LxAP_0jsDDHDRIywnUmI`,
	"App-logo": `xNMRDlpVzAXUco13r1p2`,
	"App-logo-spin": `Wo70hR4WrAm0Et8P5hto`,
	"App-header": `UpsTp6hwqyyXqujs4p7T`,
	"App-link": `_azf1A_mg91roFkz3AxY`,
	"widget-customization": `GI_qJ8RicbKre3AMqcbR`,
	"config-group": `kafNB6fnf95YmDT9rmi7`,
	"optionspreviewrow": `PDGrjD704Ob8G1kRxp1h`,
	"customization-preview-container": `IhR5wzuy5KvwHKDqdK_k`,
	"widget-preview": `HKZlGZdjjTrclIFuI7r8`,
	"notification": `WadwcjJo8Qw7oIn7USj1`,
	"video-container": `hg5c_J37HgAvDH5LSARu`,
	"divsection": `mwg5gKy0EM9GdmHaYbJM`,
	"pre-login-container": `grlaJmWeLMyGC28uwmh4`,
	"text-container": `MRUtLjwf1qiLu1G2eZ6Q`,
	"image-container": `VH1K4m8DDCw4hFvAP0UE`,
	"placeholder-image": `WZey2nQwLbLFCYMnApVe`,
	"title-text": `dgscOEiRmCgRColWrEGD`,
	"sub-text": `tAfR6PoYvluj6kXEQYA9`,
	"responsive-image": `aeLFsmoxA_by4CGRyat3`,
	"content-center": `ROMCClNVSsmfJfXdGfXJ`
};
export default ___CSS_LOADER_EXPORT___;
